import api from './api';

class ContentService {
    // Get content feed
    async getContentFeed(limit = 20, offset = 0) {
        try {
            const response = await api.get(`/content/feed?limit=${limit}&offset=${offset}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Like or unlike content
    async toggleLike(contentId) {
        try {
            const response = await api.post(`/content/${contentId}/like`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Add comment to content
    async addComment(contentId, commentText) {
        try {
            const response = await api.post(`/content/${contentId}/comment`, {
                contentId,
                commentText
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get comments for content
    async getComments(contentId, limit = 50, offset = 0) {
        try {
            const response = await api.get(`/content/${contentId}/comments?limit=${limit}&offset=${offset}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Share content
    async shareContent(contentId, shareType = 'link') {
        try {
            const response = await api.post(`/content/${contentId}/share`, {
                contentId,
                shareType
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get liked content by current customer
    async getLikedContent(limit = 20, offset = 0) {
        try {
            const response = await api.get(`/content/liked/me?limit=${limit}&offset=${offset}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Create new post (Admin only)
    async createPost(formData) {
        try {
            const response = await api.post('/content/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Pin a post
    async pinPost(contentId) {
        try {
            const response = await api.post(`/content/${contentId}/pin`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Unpin a post
    async unpinPost(contentId) {
        try {
            const response = await api.delete(`/content/${contentId}/pin`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get pinned posts for current user
    async getPinnedPosts() {
        try {
            const response = await api.get('/content/pinned/me');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get current user's posts (including pending for customers)
    async getMyPosts() {
        try {
            const response = await api.get('/content/my-posts');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get pending posts (Admin only)
    async getPendingPosts(limit = 50, offset = 0) {
        try {
            const response = await api.get(`/content/pending?limit=${limit}&offset=${offset}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Approve a post (Admin only)
    async approvePost(contentId) {
        try {
            const response = await api.post(`/content/${contentId}/approve`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Reject a post (Admin only)
    async rejectPost(contentId) {
        try {
            const response = await api.post(`/content/${contentId}/reject`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Delete a post
    async deletePost(contentId) {
        try {
            const response = await api.delete(`/content/${contentId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new ContentService();